import { connect } from 'react-redux';

import SlotSelect from '../components/SlotSelect';

import { startRequest } from '../redux/slots/actions';
import { createStructuredSelector } from 'reselect';
import { property } from 'lodash';
import { bindActionCreators } from 'redux';

const mapStateToProps = createStructuredSelector({
  slots: property('contacts.slots'),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSlots: (taxAuthorityId, serviceId) => startRequest(taxAuthorityId, serviceId),
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(SlotSelect);
